import React from "react";

import SelectStateInput from "../inputs/SelectStateInput";

const ApplicationForm = () => {
  return (
    <div className="card custom-card">
      <div className="card-header">
        <div className="card-title">New application</div>
      </div>

      <div className="card-body">
        <div className="row">
          <div className="col-md-4 mb-3">
            <label className="form-label">First Name*</label>
            <input
              name="first_name"
              type="text"
              className="form-control"
              aria-label="first name"
            />
          </div>

          <div className="col-md-2 mb-3">
            <label className="form-label">Middle Name</label>
            <input
              name="middle_name"
              type="text"
              className="form-control"
              aria-label="middle name"
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">Last Name*</label>
            <input
              name="last_name"
              type="text"
              className="form-control"
              aria-label="Last name"
            />
          </div>

          <div className="col-md-2 mb-3">
            <label className="form-label">Suffix*</label>
            <input
              name="suffix"
              type="text"
              className="form-control"
              aria-label="Suffix"
            />
          </div>

          <div className="col-md-2 mb-3">
            <label className="form-label">Date of Birth*</label>
            <input
              name="dob"
              type="text"
              className="form-control"
              aria-label="Date of Birth"
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">SSN</label>
            <input
              name="ssn"
              type="text"
              className="form-control"
              aria-label="SSN"
            />
          </div>

          <div className="col-md-4 mb-3">
            <label className="form-label">Confirm SSN</label>
            <input
              name="confirmed_ssn"
              type="text"
              className="form-control"
              aria-label="Confirm SSN"
            />
          </div>

          <div className="col-md-12 mb-3">
            <label className="form-label">Driver License</label>
            <div className="row">
              <div className="col-md-6 mb-3">
                <SelectStateInput name="driver_license_state" />
              </div>
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  name="driver_license_number"
                  placeholder="License Number"
                  className="form-control"
                  aria-label="License Number"
                />
              </div>
            </div>
          </div>

          <hr />

          <div className="col-md-12 mb-3">
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Unit Rent*</label>
                <input
                  type="number"
                  name="unit_rent"
                  placeholder="Rent ($)"
                  className="form-control"
                  aria-label="Rent"
                />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Move in Date*</label>
                <input
                  type="date"
                  name="move_in_date"
                  placeholder="Move in date"
                  className="form-control"
                  aria-label="move_in_date"
                />
              </div>
            </div>
          </div>

          <hr />

          <div className="mb-3">
            <label className="form-label">Address</label>
            <div className="row">
              <div className="col-md-9 mb-3">
                <input
                  type="text"
                  placeholder="Street"
                  className="form-control"
                  aria-label="Street"
                />
              </div>

              <div className="col-md-3 mb-3">
                <input
                  type="text"
                  placeholder="Unit/Suite"
                  className="form-control"
                  aria-label="Unit/Street"
                />
              </div>

              <div className="col-xl-5 vol-md mb-3">
                <input
                  placeholder="City"
                  type="text"
                  className="form-control"
                  aria-label="City"
                />
              </div>

              <div className="col-xl-5 mb-3">
                <SelectStateInput />
              </div>

              <div className="col-xl-2 mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Postal/Zip Code"
                  aria-label="Postal/Zip Code"
                />
              </div>
            </div>
          </div>

          <hr />

          <div className="mb-3">
            <label className="form-label">Photo Identification</label>
            <div className="text-muted mb-2">
              Accepted formats: pdf, jpg, png, gif, tiff
            </div>
            <input className="form-control" type="file" name="file" />
          </div>

          <hr />

          <div className="mb-3">
            <label className="form-label">Paystub</label>
            <div className="text-muted mb-2">
              Accepted formats: pdf, jpg, png, gif, tiff
            </div>
            <input className="form-control" type="file" name="file" />
          </div>

          <hr />

          <div className="mb-3">
            <label className="form-label">Bank Statments</label>
            <div className="text-muted mb-2">
              Accepted formats: pdf, jpg, png, gif, tiff
            </div>
            <input className="form-control" type="file" name="file" />
          </div>
        </div>
      </div>

      <div className="card-footer">
        <div className="d-flex align-items-center">
          <div className="ms-auto">
            <button className="btn btn-sm btn-success">Submit</button>
          </div>
        </div>
      </div>
    </div>
  );
};

ApplicationForm.propTypes = {};

export default ApplicationForm;
